import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { searchFilter } from '@api/filters';
import { setAiAlertsMapping } from '@store/common/actions';
import { setDefaultFilters } from '@store/filterContainer/actions';
import { ALL_TRAFFIC, PRODUCT_MODE_MAP, CURRENT_PRODUCT_MODE } from '@utils/constants';
import { track } from '@utils';
import execFor from '@utils/platform/execFor';
import { getDimensionMapping } from '@api/aiAlerts';
import { PULSE_INITIALIZATION_ERROR } from '@src/utils/sensor/track';

const initOdpContext = execFor.odp(() => {
  try {
    const matches = window.location.pathname.match(/odp\/dashboard\/(.*?)\/.*$/);
    if (matches && matches.length > 1) {
      window.conviva.contextId = matches[1];
    }
  } catch (err) {
    // pass
  }
});

const initContext = () => {
  try {
    if (Object.keys(PRODUCT_MODE_MAP).includes(CURRENT_PRODUCT_MODE)) {
      switch (CURRENT_PRODUCT_MODE) {
        case PRODUCT_MODE_MAP.EI:
          window.conviva.context = 'video';
          break;
        case PRODUCT_MODE_MAP.AI:
          window.conviva.context = 'ad';
          break;
        case PRODUCT_MODE_MAP.APP:
          window.conviva.context = 'app';
          break;
        default:
          CURRENT_PRODUCT_MODE.toLowerCase();
          break;
      }
    }
  } catch (err) {
    // ignore
  }
};

// load default filter (only All Traffic for now)
// required for NOC
const initDefaultFilters = async () => {
  const resp = await searchFilter({ name: ALL_TRAFFIC, isDefault: 1, isModifiable: 0 });
  return resp.data;
};

// not sure if this is required on init itself
// saga was triggering this call on load (without watcher)
const initAiAlertDimensions = async () => {
  const resp = await getDimensionMapping();
  return resp.data;
};

export default () => {
  initOdpContext();
  initContext(); // for video/ad/eco

  // interval should not be consumed here as it casues app level re-renders
  // initialize should only happen once and in the first run interval is always empty
  // also interval changes don't re-run the effect hook so consuming it make less sense
  // const interval = useSelector(intervalSelector);

  const [error, setError] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();

  /* this doesn't seem to be used, triggering click events to parent
  useEffect(() => {
    document.addEventListener('click', clickDocument);
    return () => document.removeEventListener('click', clickDocument);
  }, []);
  */

  useEffect(() => {
    Promise.all([initDefaultFilters(), initAiAlertDimensions()])
      .then(([defaultFilters, aiAlertDimensionMapping]) => {
        dispatch(setDefaultFilters([defaultFilters]));
        dispatch(setAiAlertsMapping(aiAlertDimensionMapping));
        setInitialized(true);
      })
      .catch((err) => {
        console.error(PULSE_INITIALIZATION_ERROR, err);
        track({
          event: PULSE_INITIALIZATION_ERROR,
          data: { error },
        });
        setError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setInitialized, dispatch]);

  return [initialized, error];
};
